module.exports = __webpack_public_path__ + "img/pr-5.f2c3eb4e.png";